import HomePage from "./home";

export { HomePage };
